import { iLoginResponse } from "core/kangarooTypes/iLoginResponse";
import ApiService from "./api";
import { iMerchantRegistration } from "core/kangarooTypes/iMerhantReristration";

export const login = (
  email: string,
  password: string
): Promise<iLoginResponse> => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);

  return ApiService.fetchData({
    url: `login`,
    method: "POST",
    data: formData,
  });
};

export const merchantRegistration = (
  data: iMerchantRegistration
): Promise<any> => {
  const formData = new FormData();
  formData.append("first_name", data.first_name);
  formData.append("last_name", data.last_name);
  formData.append("business_name", data.business_name);
  formData.append("phone_number", data.phone_number);
  formData.append("email", data.email);
  formData.append("password", data.password);
  if (data.lat) formData.append("lat", data.lat);
  if (data.long) formData.append("long", data.long);
  if (data.address_name) formData.append("address_name", data.address_name);
  if (data.address) formData.append("address", data.address);

  return ApiService.fetchData({
    url: `register-merchant`,
    method: "POST",
    data: formData,
  });
};

export const forgetPassword = (email: string): Promise<any> => {
  const formData = new FormData();
  formData.append("email", email);

  return ApiService.fetchData({
    url: `forgot-password`,
    method: "POST",
    data: formData,
  });
};

export const resetPassword = (
  email: string,
  token: string,
  password: string,
  password_confirmation: string
): Promise<any> => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("token", token);
  formData.append("password", password);
  formData.append("password_confirmation", password_confirmation);
  return ApiService.fetchData({
    url: `update-password`,
    method: "POST",
    data: formData,
  });
};

export const sendOtp = (email: string): Promise<any> => {
  const formData = new FormData();
  formData.append("email", email);

  return ApiService.fetchData({
    url: `send-otp`,
    method: "POST",
    data: formData,
  });
};
export const verifyOtp = (email: string, otp: string): Promise<any> => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("otp", otp);

  return ApiService.fetchData({
    url: `verify-otp`,
    method: "POST",
    data: formData,
  });
};
